
import { Vue } from "vue-class-component";

export default class Scan extends Vue {}
